import React from 'react';
import { Wrench } from 'lucide-react';
import { PersistedWorkflow } from '@cotera/sdk/core';
import { Text } from '@cotera/client/app/components/ui';
import type { WorkflowNodeRenderStrategy } from '../types';
import { asRecord, readString } from '../../utils';

const { WorkflowNodeType } = PersistedWorkflow;

export const completeToolCallNodeStrategy: WorkflowNodeRenderStrategy = {
  nodeType: WorkflowNodeType.CompleteToolCall,
  accent: 'tool',
  badge: 'Tool',
  getTitle: () => 'Complete tool call',
  getDescription: (node) => {
    const toolCallId = readString(asRecord(node.data), 'toolCallId');
    return toolCallId !== undefined
      ? `Tool call ${toolCallId.slice(0, 8)}…`
      : undefined;
  },
  renderIcon: () => <Wrench className="h-4 w-4" />,
  renderBody: (node) => {
    const record = asRecord(node.data);
    const parentModel = readString(record, 'parentModel');
    return (
      <Text.Caption className="text-muted-foreground block truncate">
        {parentModel !== undefined
          ? `Parent model: ${parentModel}`
          : 'Resumes a pending tool call in chat.'}
      </Text.Caption>
    );
  },
};
